import { Status } from '../status/status.enum';
export const FieldClaimDefault = [
    {
        label: 'created_at',
        type: 'date',
        properties: ['createdAt']
    },
    {
        label: 'finish_date',
        type: 'date',
        properties: ['finishedAtTimestamp']
    },
    {
        label: 'deadline_selfadjust',
        type: 'date',
        properties: ['deadlineSelfadjust'],
        editable: true
    },
    {
        label: 'template',
        type: 'list',
        properties: ['template'],
        editable: true
    }
];
export const EditableDefaultClaimFields = {
    deadline_selfadjust: [Status.NEW, Status.IN_PROGRESS, Status.REOPENED],
    template: [Status.NEW],
    assigned_agent_name: [Status.NEW, Status.IN_PROGRESS, Status.REOPENED]
};
export const overridableEditableClaimFields = ['assigned_agent_name'];
